module.exports = __webpack_public_path__ + "img/skills.56660770.svg";